<template>
  <!-- 直播视频 组件二次封装，将websocket等处理封装到此处。该组件适用于界面仅播放单个直播的场景 该参数传递时需要增加 .sync 修饰符，因为关闭窗口时会修改该参数  使用示例：<LiveVideoPlus :deviceProp.sync="liveVideoProp"></LiveVideoPlus> -->
  <LiveVideo
    v-if="device && device.serialNumber"
    ref="liveVideo"
    :device="device"
    @close="closeVideo"
    @handleVideo="handleVideo"
    :ipcVideo="deviceProp.helpType ? true : false"
  ></LiveVideo>
</template>

<script>
import LiveVideo from '@/views/monitor/live/LiveVideo.vue'
import { setHandleHelmetOperationResponse, sendLiveUrlRequest, exitLiving, grabRecord } from '@/common/websocket/live'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { warning } from '@/api/common'
import { confirmWin } from '@/util/common'
import { getLiveUrl } from '@/common/live'
export default {
  props: {
    // 设备属性
    deviceProp: {
      type: Object,
      default: () => {
        return {
          // 用户名称
          name: '',
          // 头盔序列号
          serialNumber: null,
          // 设备类型
          specType: 3,
          // 用户id,用于指令操控
          userId: 1,
        }
      },
    },
  },
  data() {
    return {
      device: {
        // 用户名称
        name: '',
        // 头盔序列号
        serialNumber: null,
        // 视频地址，websocket自动获取
        liveUrl: null,
        // 设备类型
        specType: 3,
        // 用户id,用于指令操控
        userId: 1,
      },
      // 视频监控是否加载中，用于防抖
      loading: false,
    }
  },
  components: {
    LiveVideo,
  },
  name: 'LiveVideoPlus',
  methods: {
    // 关闭直播视频
    closeVideo(serialNumber) {
      // let index = this.listPlayVideoSerialNumber.indexOf(serialNumber)
      // console.log(serialNumber, 'index')
      // if (serialNumber && index !== -1) {
      //   this.listPlayVideo.splice(index, 1)
      //   if (this.listPlayVideo.length === 0) {
      //     this.closeBroad()
      //     this.$store.commit('openVedio', false)
      //   }
      // }
      // this.changeList()
      this.device = null
      exitLiving(serialNumber)
      this.$emit('update:deviceProp', {})
      // 触发自定义关闭事件
      this.$emit('closeLiveVideo')
      this.device = {
        name: '',
        serialNumber: null,
        liveUrl: null,
        specType: 3,
        userId: 1,
      }
      this.$store.commit('changeHelpInfo', {
        serialNumber: null,
        username: null,
        userId: null,
      })
    },
    // 开启实时视频模式
    handleVideo(data) {
      console.log('实时视频弹窗', data)
      this.closeVideo(data.device.serialNumber)
      this.dialogVisible = true
      this.realVideoData = {
        serialNumber: data.device.serialNumber,
        username: data.name,
      }

      this.currentItem = data.device
      this.deviceName = data.device.deviceName
      this.liveBroadcast.currentNode = data
      this.allowClick = data.device.specType === 1 ? false : true
    },
    // 自定义处理获取到直播链接事件
    handleLiveUrlResponse(serialNumber, liveUrl, resolutionP) {
      this.device.liveUrl = getLiveUrl(liveUrl)
    },
    // 直播时处理websocket响应
    handleHelmetOperationResponse(params) {
      // console.log(params,6666)
      // action:0=加入，1=离开，2=切换分辨率，3=直播进入，4=直播停止
      // {"action":1,"camera":0,"gps":0,"laser":0,"led":0,"readdingLamp":0,"rfid":0,"warnningLamp":0}
      // {"action":0,"ihVersion":"21","isAgoraSpeech":false,"isAudioRecord":false,"isFaceScan":false,
      // "isQRScan":false,"isRecord":false,"isRecordVoiceOpen":true,"isSwitchUser":false,"isWebRtcConn
      // ect":false,"netWorkState":1,"roomId":0}
      // {"action": 2,"enterResult":false}
      // {"cloudRoomType":"3","channelId":"H-100-001","status":"{\"action\":3,\"startLiveResult\":true,\"liveUrl\":\"http:xxxx\",\"errorMsgType\":0,\"roomId\":12345}"}
      var status = JSON.parse(params.status)
      console.log('handleHelmetOperationResponse', status)
      // 通过安全帽id获取到对应的用户名
      let name = this.device.name
      let userId = this.device.userId
      if (status.action === 2) {
        // 安全帽加入房间失败
        if (!status.enterResult) {
          errorCollection('实时监控', '安全帽视频连接', {
            status: 200,
            data: { state: -1, msg: '安全帽视频连接失败，请重新连接' },
          })
          console.error(name + '安全帽视频连接失败，请重新连接!')
        }
        return
      }

      if (status.action === 1) {
        console.log(`拍照状态:${status.camera}`)
        return
      }

      if (status.isFaceScan) {
        warning(name + '正在进行人脸识别，请稍后连接!')
        return
      }
      if (status.isQRScan) {
        warning(name + '安全帽正在进行二维码扫描，请稍后连接!')
        return
      }
      if (status.isSwitchUser) {
        warning(name + '正在进行切换用户，请稍后连接!')
        return
      }
      if (status.isAgoraSpeech) {
        warning(name + '麦克风已被占用!')
        return
      }
      if (status.isRecord) {
        confirmWin(
          name + this.$t('RecordingPreemptOrNot'),
          () => {
            grabRecord(params.helmetId)
          },
          () => {
            // 点击取消事件 关闭直播框
            this.closeVideo(params.helmetId)
          }
        )
        return
      }
      // 开始直播或者直播切换分辨率
      console.log(
        'this.$store.state.isUserSend',
        this.$store.state.isUserSend,
        this.device.serialNumber,
        params.helmetId
      )
      if (status.action === 3) {
        if (status.errorMsgType === 1) {
          this.realVideoSeize(params.helmetId, name, userId)
        } else if (status.errorMsgType === 2) {
          errorCollection('实时监控', '打开摄像头', { status: 200, data: { state: -1, msg: '打开摄像头失败，请重试' } })
          warning(name + '打开摄像头失败，请重试！')
        } else if (status.liveUrl) {
          // this.$nextTick(() => {
          //   this.$refs.livechild[helmetIndex].changeReaolution(status.resolution)
          // })

          if (this.$store.state.isUserSend && this.device.serialNumber === params.helmetId) {
            // 延时防止快速点击多个直播时不触发直播链接
            // setTimeout(() => {
            this.$store.commit('userSend', false)
            this.handleLiveUrlResponse(params.helmetId, status.liveUrl, status.resolution)
            // }, 1000)
          }
        }
      }
      //当直播被会议抢占时，退出关闭视频窗口，弹窗提示
      if (status.action === 4) {
        if (status.stopEventType === 1) {
          // 视频会议抢占导致直播停止
          console.log('视频会议抢占导致直播停止', params.helmetId, name, status.userId)
          this.realVideoSeize(params.helmetId, name, userId)
        } else if (status.stopEventType === 0) {
          // 正常停止直播
          console.log('正常停止直播')
        }
      }
    },
  },
  mounted() {
    // prop -> data
    this.device.name = this.deviceProp.name
    this.device.serialNumber = this.deviceProp.serialNumber
    this.device.specType = this.deviceProp.specType
    this.device.userId = this.deviceProp.userId
    setHandleHelmetOperationResponse(this.handleHelmetOperationResponse)
    // 延迟0.5s防止快速点击多个直播可能出不来视频
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 500)
    // 发起直播请求
    sendLiveUrlRequest(this.device.serialNumber)
  },
  beforeDestroy() {
    // 退出后清空消息响应处理
    setHandleHelmetOperationResponse(() => {})
  },
}
</script>

<style></style>
